import React from "react"
import { styled } from "baseui"
import { Theme } from "baseui/theme"
import Common from "./Common"
import Scenes from "./Scenes"

const Container = styled<"div", {}, Theme>("div", ({ $theme }) => ({
  background: $theme.colors.white,
}))

const Graphic = () => {
  return (
    <Container className="bottom-bar ">
      <div className="bottom-bar-inner w-full flex items-center">
        <div
          style={{
            background: "white",
          }}
          className="m-1  p-3 rounded-xl mb-2 custom-container "
        >
          <Common />
        </div>
        <div
          style={{
            background: "white",
          }}
          className="w-full p-3 custom-container"
        >
          <Scenes />
        </div>
      </div>
    </Container>
  )
}

export default Graphic
